export default __webpack_public_path__ + "static/media/credit-card.4ae0708b.svg";